import { Link } from 'react-router-dom';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import graphFetch from '../../../util/graphFetch';

import Button from '../../Button';

import * as actions from '../../../redux/actions';
import dateFormat from '../../../util/dateFormat';
import { getAllUsers } from '../../../redux/selectors';
import { Head, Wrap, Body, SiteUL } from './Accounts.stc';

function Accounts(props) {
    const dispatch = useDispatch();
    const users = useSelector(getAllUsers);

    const handleDeleteUser = useCallback(
        (id) => {
            const ok = window.confirm(
                'Are you sure that you want to delete the user parmanently?'
            );
            ok && dispatch(actions.deleteUser(id));
        },
        [dispatch]
    );

    const suspendUser = useCallback(async (id) => {
        const ok = window.confirm(
            'Are you sure that you want to suspend the user?'
        );
        if (!ok) return;
        const options = {
            queryName: 'suspendUser',
            select: 'message success',
            args: { id: { type: 'ID!', value: id } },
        };
        const data = await graphFetch(options, true);
        console.log(data);
    }, []);

    const unSuspendUser = useCallback(async (id) => {
        const ok = window.confirm(
            'Are you sure that you want to un-suspend the user?'
        );
        if (!ok) return;
        const options = {
            queryName: 'unSuspendUser',
            select: 'message success',
            args: { id: { type: 'ID!', value: id } },
        };
        const data = await graphFetch(options, true);
        console.log(data);
    }, []);

    const getPlanName = useCallback((membership) => {
        switch (membership?.planId) {
            case 591501:
                return 'PLAN_1 : STARTER';
            case 592743:
                return 'PLAN_2 : PREMIUM';
            case 599617:
                return 'PLAN_3 : LIFETIME';
            default:
                return 'FREE';
        }
    }, []);

    useEffect(() => {
        dispatch(actions.getUsers());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (users) {
        return users.map((user, i) => (
            <Wrap key={user.id} data-user-id={user.id}>
                <Head>
                    <div className="f-2">
                        Account: <strong>{user.email}</strong>{' '}
                        <Button
                            size="sm"
                            type="danger"
                            onClick={() => handleDeleteUser(user.id)}
                        >
                            <FontAwesomeIcon icon={['far', 'trash-alt']} />
                        </Button>{' '}
                        {!user?.isBanned ? (
                            <Button
                                size="sm"
                                type="danger-alt"
                                onClick={() => suspendUser(user.id)}
                            >
                                <FontAwesomeIcon icon={['far', 'user-slash']} />
                            </Button>
                        ) : (
                            <Button
                                size="sm"
                                type="primary-alt"
                                onClick={() => unSuspendUser(user.id)}
                            >
                                <FontAwesomeIcon icon={['far', 'user']} />
                            </Button>
                        )}
                    </div>
                    <div>
                        Plan: <strong>{getPlanName(user.membership)}</strong>
                    </div>
                    <div>
                        Created On:{' '}
                        <strong> {dateFormat(user.createdAt)}</strong>
                    </div>
                </Head>
                <Body>
                    <div className="f-2">
                        <p>
                            <strong>Websites</strong>
                        </p>
                        <SiteList sites={user.sites} />
                    </div>
                    <div>
                        <p>
                            <strong>Plan Details</strong>
                        </p>
                    </div>
                    <div>
                        <p>
                            <strong>Account Control</strong>
                        </p>
                    </div>
                </Body>
            </Wrap>
        ));
    } else {
        return null;
    }
}

export default Accounts;

function SiteList({ sites = [] }) {
    const dispatch = useDispatch();

    const handleDeleteSite = useCallback(
        (id) => {
            const ok = window.confirm(
                'Are you sure that you want to delete the site parmanently?'
            );
            ok && dispatch(actions.deleteSite(id));
        },
        [dispatch]
    );

    return (
        <SiteUL className="unstyle">
            {!sites.length
                ? null
                : sites.map((site, i) => (
                      <li key={site.id}>
                          Site:{' '}
                          <Link to={`/builder?site=${site.id}`} target="_blank">
                              {site.id}
                          </Link>{' '}
                          {site.url && (
                              <span>
                                  ({' '}
                                  <a
                                      href={`https://${site.url}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                  >
                                      {site.url}
                                  </a>{' '}
                                  )
                              </span>
                          )}{' '}
                          <Button
                              onClick={() => handleDeleteSite(site.id)}
                              type="danger"
                              size="sm"
                          >
                              <FontAwesomeIcon icon={['far', 'trash-alt']} />
                          </Button>
                      </li>
                  ))}
        </SiteUL>
    );
}
